export class DocumentType {
  static Undefined = 1;
  static ClaimDocumentation = 2;
  static StandardInspectionPhoto = 3;
  static RepairProcessPhoto = 4;
  static AfterRepairProcessPhoto = 5;
  static AddOnPhoto = 6;
  static ForEstimationPhoto = 7;
  static InspectionMovie = 8;
  static CostEstimation = 9;
  static GeneratedDocument = 10;
  static WebSiteFormDocument = 11;
  static PortalMessage = 12;
  static SystemDocument = 13;
  static PartsOrderInvoice = 14;
  static InspectionCard = 15;
  static CostInvoice = 16;
  static ExportCostInvoicesPaymentsToIng = 17;
  static ExportCostInvoicesToRamzes = 18;
  static NonAssociatedPhoto = 19;
  static EntityDocument = 20;
  static InvoiceDocument = 21;
  static ExportCostInvoicesToCalculationArt = 22;
  static DuplicateInvoiceDocument = 23;
  static InvoiceCorrectionDocument = 24;
  static ExportInvoicesToCalculationArt = 25;
  static CarReceptionDataProtocol = 26;
  static CarReceptionDataProtocolPhoto = 27;
  static CarReceptionDataReturnProtocol = 28;
  static CarReceptionDataReturnProtocolPhoto = 29;

  static CarRentAgreementPhoto = 30;
  static CarRentAgreement = 31;
  static CarRentAgreementReturnPhoto = 32;
  static CarRentAgreementReturn = 33;

   static CarRentalFleetCarElementPhoto = 34;
   static BusinessTripDocument = 35;
   static BusinessTripAttachment = 36;
   static InvoiceAttachment = 37;
   static CostInvoiceForClassification = 38;
   
  public static isPhotoDocumentation(documentTypeId){
    return documentTypeId >= DocumentType.StandardInspectionPhoto && documentTypeId <= DocumentType.ForEstimationPhoto ||
    documentTypeId == DocumentType.NonAssociatedPhoto;
  }

  public static isMovieDocumentation(documentTypeId){
    return documentTypeId == DocumentType.InspectionMovie;
  }
}
